import React, { useEffect, useCallback, useState} from 'react';
import Colors from 'components/Colors.js';
import {useTags} from '../links/useTags.js';
import TagEditor from '../links/TagEditor.js';
import {useComments} from '../comments/useComments.js';
import ConditionedComponent from "components/ConditionedComponent.js";
import {connect} from 'react-redux';
import {useProjectMetadata} from "components/explore/useProjectMetadata.js";

const colors = new Colors();

const WorkMetadata = ({
    work,
    showComments,
    setSearchTag,
    editTags=true
}) => { 
    work.id = work.newSequence;
    const [works, setWorks] = useState([work]);
    const {comments} = useComments({works});
    const [showTags, setShowTags] = useState(false);
    const {tags} = useTags({work});

    const {
        isStarred,
        showStar,
        isFavorited,
        onStarClicked,
        onFavoriteClicked} = useProjectMetadata({track: work});

    const onClickTag = useCallback((e, tag) => {
        e.stopPropagation();
        setSearchTag(tag);
    }, [setSearchTag]);

    let className = "work-metadata";
    if (showTags) {
        className += " showing-tags";
    }
    return (
        <div className={className}>
        <div className="metadata-inner">
          <div className="work-tags">
            {!editTags ? tags
             .filter(x => x)
             .map(
                x =>
                    <div
                      onClick={(e) => onClickTag(e, x)}
                      className="work-tag">{x}
                    </div>
            ) : ''}</div>
          {showTags ? <TagEditor work={work}/> : ''}
          <img
            onClick={() => setShowTags(!showTags)}
            className={showTags ? "show tag-icon" : "tag-icon"} src="/tag.svg"/>
          {showComments && comments.length > 0 ?
           <img className="comments-icon" src="/comments.svg"/> : ""}
          <ConditionedComponent condition={showStar}>
            <div
              onClick={onStarClicked}
              className={isStarred ? "star starred" : "star"}>
                <span>&#9734;</span>
            </div>
          </ConditionedComponent>
          <div onClick={onFavoriteClicked} className={isFavorited ? "heart favorited" : "heart"}/>
        </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkMetadata);
